export default __webpack_public_path__ + "static/media/X.5a65e630.svg";